import { gql } from '@apollo/client';

const schema = {
  get: {
    name: 'productShop',
    serviceName: 'grapghql',
    query: gql`
      query productShop($ids: [String], $for_admin: Int) {
        productShop(ids: $ids, for_admin: $for_admin) {
          products {
            data {
              id
              stock
              co_price
              me_price
              unit_fie {
                id
                title
              }
              fie
              is_active
              max_number_buy
              nonexistent_number
              shop {
                id
              }
              booth {
                id
              }
              details
            }
          }
        }
      }
    `,
  },
  update: {
    name: 'updateProductShop',
    serviceName: 'shopadmin',
    query: gql`
      mutation updateProductShop(
        $ids: [String]
        $shop_id: String
        $booth_id: String
        $co_price: String
        $me_price: String
        $unit_fie_id: String
        $fie: String
        $stock: String
        $max_number_buy: String
        $nonexistent_number: String
        $is_active: Int
        $details: String
      ) {
        updateProductShop(
          ids: $ids
          shop_id: $shop_id
          booth_id: $booth_id
          co_price: $co_price
          me_price: $me_price
          unit_fie_id: $unit_fie_id
          fie: $fie
          stock: $stock
          max_number_buy: $max_number_buy
          nonexistent_number: $nonexistent_number
          is_active: $is_active
          details: $details
        ) {
          influenced_count
          messages
        }
      }
    `,
  },
};

export default schema;
